import React from 'react';
import classNames from 'clsx';

interface GalleryImageProps {
  url: string;
  className?: string;
}

const GalleryImage = ({ url, className }: GalleryImageProps) => (
  <div style={{ backgroundImage: `url(${url})` }} className={classNames('pd-bg-center pd-bg-no-repeat pd-bg-contain pd-aspect-square pd-w-full', className)} />
);

export default GalleryImage;
